import {delay, first} from 'rxjs/operators';
import {of} from 'rxjs';

export function setTimeout$(cb: () => void, timer: number) {
    of(true).pipe(delay(timer), first()).subscribe(cb);
}
